<template>
  <div>

      <header>


        <div class="hyper-link">
          <a href="#search"  class="btn btn-lg shadow" style="background-color: #00f1ff; color: #131b97">¿Qué te gustaría estudiar o aprender?</a>
          <a href="/perfil" class="btn btn-lg shadow" style="background-color: #00f1ff; color: #131b97">¿Eres capacitador?</a>
        </div>

        <img v-responsive.xl src="@/assets/@banners/@responsive/search-cursos/banner-cursos-interior-1680x1050.jpg" alt="" class="w-100 _img">
        <img v-responsive.lg.md  src="@/assets/@banners/@responsive/search-cursos/banner-cursos-interior-1024x768.jpg" alt="" class="w-100 _img">
        <img v-responsive.sm  src="@/assets/@banners/@responsive/search-cursos/banner-cursos-interior-768x1024.jpg" alt="" class="w-100 _img">
        <img v-responsive.xs  src="@/assets/@banners/@responsive/search-cursos/banner-cursos-interior-500x750.jpg" alt="" class="w-100 _img">
    </header>

    <section id="search" style="border-top: 2px solid #1d03e5" class="py-5">
      <div class="container">
        <div class="row">
          <div class="col-lg-8">
            <b-form @submit="searchCurses">
              <h1 class="font-weight-bold font-blue">¡Busca un curso!</h1>
              <div class="__controls-head d-flex mt-4">
                <b-form-input
                  type="text"
                  class="border-0 shadow-sm p-4"
                  v-model="search"
                  placeholder="¿Qué quieres aprender hoy?"
                  autocomplete="off"
                ></b-form-input>
                <b-button
                  type="submit"
                  class="btn b-orange ml-2 shadow-lg"
                  :disabled="loading.search">
                  <b-spinner v-if="loading.search" small label="Espere ..."></b-spinner>
                  <i class="fas fa-search" v-show="!loading.search"></i>
                </b-button>
              </div>
              <!-- <div class="__controls-filter d-flex mt-2" v-if="advanceFilter">
                                <b-form-group label="Ciudad, Estado, Pais" class="col-lg-4 p-1">
                                    <b-form-input type="text"  class="border-0" v-model="advanseSearch.city" placeholder="Ej. Guadalajara" autocomplete="off"></b-form-input>
                                </b-form-group>
                                <b-form-group label="Sueldo" class="col-lg-4 p-1">
                                    <b-form-input type="text"  class="border-0" v-model="advanseSearch.payment" placeholder="Ej. 5000" autocomplete="off"></b-form-input>
                                </b-form-group>
                                <b-form-group label="Tipo de empleo" class="col-lg-4 p-1">
                                    <b-form-select class="border-0"  v-model="advanseSearch.type" :options="tipos_empleo"></b-form-select>
                                </b-form-group>
              </div>-->
              <!-- <button type="button" class="btn b-transparent font-gray-dark" @click="advanceFilter = !advanceFilter">{{advanceFilter ? 'Ocultar opciones avanzadas' : 'Más opciones'}}</button> -->
              <div class="font-weight-light mt-3">Encuentra y Compara CURSOS en Kllaar.com</div>
              <small class="font-weight-light">*Todos nuestros cursos están validados por profesionales.</small>
            </b-form>

          </div>
        </div>
      </div>
    </section>
    <section class="b-white shadow-sm" v-if="!isLoggedIn">
      <div class="container">
        <div class="row">
          <div class="col-md-12 py-4">
            ¿Quieres formar parte de nuestros capacitadores? puedes
            <router-link to="/registrar" class="font-orange">registrarte </router-link>de forma gratuita.
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="container">
        <div class="row">
            <CurseMini
              v-for="curse in curses"
              :key="curse.id"
              :title="curse.title"
              :description="curse.description"
              :students="0"
              :rating="0"
              :cover="curse.cover"
              :url_public="curse.url_public"
              :curse="curse"

            />
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="d-flex flex-wrap justify-content-between">
              <ExternalCourseItem
                v-for="course in externalCourses"
                :key="course.course_name"
                :title="course.course_name"
                :cover="course.url_cover_page"
                :href="course.course_url"

              />
          </div>
        </div>
      </div>
    </section>

    <!--Recomendations-->
    <section class="b-white" v-if="cursesRecomendation && cursesRecomendation.length > 0">
      <div class="row">
        <div class="col-lg-12 text-center py-4">
          <h5 class="fas fa-video"></h5>
          <h4>Cursos recomendados para tu perfil</h4>
        </div>
        <div class="container pb-5">
          <div class="col-lg-12 d-flex flex-wrap justify-content-start">
<!--            <CurseMini-->
<!--              v-for="curse in cursesRecomendation"-->
<!--              :key="curse.id"-->
<!--              :cover="curse.cover"-->
<!--              :title="curse.title"-->
<!--              :description="curse.description"-->
<!--              :rating="curse.rating"-->
<!--              :students="curse.rating"-->
<!--              :url_public="curse.url_public"-->
<!--            />-->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style lang="scss" scoped>


  .hyper-link{
    position: absolute;
    @media only screen and (max-width : 543px){
      margin-top: 58vw;
      text-align: center;
      padding: 10px 0 10px 0px;
      a{
        font-size: 2.6vw;
      }
    }
    @media only screen and (min-width : 544px){
      margin-top: 45vw;
      text-align: center;
      a{
        font-size: 2.5vw
      }
      padding: 10px 0 10px 0px;
    }
    @media only screen and (min-width : 768px){
      margin-top: 33vw;
      text-align: left;
      a{
        font-size: 1.6vw;
      }
      padding: 10px 0 10px 5.6vw;
    }
    @media only screen and (min-width : 992px){
      margin-top: 33vw;
      text-align: left;
      a{
        font-size: 1.8vw;
      }
      padding: 10px 0 10px 6vw;
    }
    width: 100%;
  }
</style>
<script>
import CurseMini from "./components/home/CurseMini";
import ExternalCourseItem from "./components/home/ExternalCourseItem";

export default {
  components: {
    CurseMini: CurseMini,
    ExternalCourseItem
  },
  data() {
    return {
      loading: {
        search: false,
        curses: false
      },
      search: null,
      advanceFilter: false,
      advanseSearch: {
        city: "",
        payment: "",
        type: ""
      },
      curses: [],
      externalCourses: [],
    };
  },
  computed: {
    typeOrigin: function() {
      return this.$store.getters.typeOrigin;
    },
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn;
    },
    cursesRecomendation: function() {
      return this.$store.getters.cursesRecomendation;
    }

  },
  methods: {
    loadCurses() {
      this.api
        .get("curse/home")
        .then(({ data }) => {
          this.curses = data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    recomendations() {

    },
    searchCurses(evt) {
      evt.preventDefault();
      this.loading.search = true;
      this.api
        .get("curse/home?q=" + this.search)
        .then(({ data }) => {
          this.loading.search = false;
          this.curses = data.kllaar_results.data;
          this.externalCourses = data.external_results.data;

          console.log(this.externalCourses)
        })
        .catch(err => {
          this.loading.search = false;
          console.log(err);
        });
    }
  },
  created() {
    // this.loadCurses()
    if (this.typeOrigin == "student") {
      this.recomendations();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/#public/curse/CursesHome.vue